// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ASK_AN_EXPERT = "Poradny";
export const BADGE_REDACTION = "Redakce";
export const CONTESTS = "Sout\u011b\u017ee";
export const HOMEPAGE_FEED_NAV_TAB_FORUM = "Diskuse";
export const HOMEPAGE_FEED_NAV_TAB_PHOTOBLOGS = "Blogy";
export const HOMEPAGE_NEW_ANNOUNCEMENT = "Ocitla ses na nov\u00e9 \u00favodn\u00ed str\u00e1nce";
export const HOMEPAGE_NEW_CONTACT_FORM = "M\u00e1\u0161 k nov\u00e9 \u00favodn\u00ed str\u00e1nce p\u0159ipom\u00ednky nebo n\u00e1vrhy?";
export const HOMEPAGE_NEW_CONTACT_FORM_LINK = "Napi\u0161 n\u00e1m pros\u00edm!";
export const HOMEPAGE_NEW_CONTACT_FORM_LINK_URL = "https://www.modrykonik.cz/faq/form/";
export const HOMEPAGE_OLD_SWITCH = "P\u0159epnout na starou";
export const HOME_SHOW_MORE_POSTS = "Zobraz dal\u0161\u00ed";
export const MAIN_MENU_REVIEWS = "Recenze";
